import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export type SortKey = "run_cost" | "bytes_scanned" | "start_time" | "execution_time";
export type SortOrder = "asc" | "desc";

export const RUN_STATUS_OPTIONS = [
  { label: "All", value: "all" },
  { label: "Success", value: "success" },
  { label: "Failed", value: "fail" },
];

export const useWorkloadRunListParams = (setPage: (page: number) => void) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const sortKey = (searchParams.get("sort_key") as SortKey) || "start_time";
  const sortOrder = (searchParams.get("sort_order") as SortOrder) || "desc";
  const runStatusFilter = searchParams.get("run_status") || undefined;

  const handleRunStatusChange = useCallback(
    (value: unknown) => {
      setSearchParams(
        prev => {
          if (typeof value === "string" && value && value !== "all") {
            prev.set("run_status", value);
          } else {
            prev.delete("run_status");
          }
          return prev;
        },
        { replace: true }
      );
      setPage(0);
    },
    [setSearchParams, setPage]
  );

  return {
    sortKey,
    sortOrder,
    runStatusFilter,
    handleRunStatusChange,
  };
};
